(() => {
    const launcherSelector = '.all-escorts-map-launcher';
    const scriptUrl = document.currentScript?.dataset.overlaySrc;
    let overlayPromise = null;
    let pendingLauncher = null;

    if (!scriptUrl) return;

    function loadOverlay() {
        if (overlayPromise) return overlayPromise;

        overlayPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = scriptUrl;
            script.defer = true;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });

        overlayPromise.then(() => {
            document.removeEventListener('click', openAfterLoad, true);
        }).catch(() => {
            overlayPromise = null;
        });

        return overlayPromise;
    }

    function warmOverlay(event) {
        if (event.target.closest(launcherSelector)) {
            loadOverlay();
        }
    }

    async function openAfterLoad(event) {
        const launcher = event.target.closest(launcherSelector);
        if (!launcher) return;

        event.preventDefault();
        if (pendingLauncher) return;

        pendingLauncher = launcher;
        try {
            await loadOverlay();
            const launcherToOpen = pendingLauncher;
            pendingLauncher = null;
            launcherToOpen.click();
        } catch (error) {
            pendingLauncher = null;
            window.location.hash = launcher.getAttribute('href') || '#allEscortsMapOverlay';
        }
    }

    document.addEventListener('pointerover', warmOverlay, { passive: true });
    document.addEventListener('focusin', warmOverlay);
    document.addEventListener('touchstart', warmOverlay, { passive: true });
    document.addEventListener('click', openAfterLoad, true);
})();